import React from 'react';
import { useParams } from 'react-router';

import { FiveHundredErrorPage } from '@sm/webassets';
import usePricingExperience from '~pricing/lib/PricingExperience';
import { PackageType } from '~pricing/lib/summaryPackages';
import { PricingExperienceProvider } from '~pricing/lib/PricingExperience/PricingExperienceContext';
import { INDIVIDUAL_PACKAGES, TEAMS_PACKAGES } from '~pricing/lib/constants';

type MatchParams = {
  canonicalPath: string;
};

export function withPageHandler<P>(WrappedComponent: React.ComponentType<P>): React.ComponentType<P> {
  return props => {
    const { canonicalPath = PackageType.Teams } = useParams<MatchParams>();
    const packageSet = canonicalPath === PackageType.Individual ? INDIVIDUAL_PACKAGES : TEAMS_PACKAGES;

    const { error, loading, data } = usePricingExperience();
    return (
      <Choose>
        {/* if there was an issue loading the data from pricingsvc, we've got nothing to show. bail */}
        <When condition={error}>
          <FiveHundredErrorPage />
        </When>
        <When condition={!error && !loading && data}>
          <PricingExperienceProvider value={data.pricingPageExperience.packages}>
            <WrappedComponent packageData={data.pricingPageExperience.packages} packageSet={packageSet} {...props} />
          </PricingExperienceProvider>
        </When>
      </Choose>
    );
  };
}

export default withPageHandler;
